module.exports = __webpack_public_path__ + "static/media/lizna_charaniya.39b6db24.png";